import { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import SEO from '../../components/SEO';

const TermPage = () => {
    return (
        <Fragment>
            <SEO 
                title="Terms & Conditions | Wilson Tamuka Attorneys | Legal Engagement Terms"
                description="Terms and conditions of engagement with Wilson Tamuka Attorneys. Learn about our professional legal services, fees, client responsibilities, and engagement terms."
                keywords="legal terms Zimbabwe, attorney engagement terms, legal services terms, Law Society of Zimbabwe, legal fees Zimbabwe"
                canonical="https://wtafirm.co.zw/terms"
            />
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'}/>
            <PageTitle pageTitle={'Terms & Conditions'} pagesub={'Terms & Conditions'} />
            <section className="wpo-terms-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="wpo-terms-wrap">
                                <div className="wpo-terms-text">
                                    <h2>Terms and Conditions of Engagement</h2>
                                    <p>These Terms and Conditions govern the professional relationship between Wilson Tamuka Attorneys (WTA) and our clients. By engaging our services, you agree to these terms.</p>

                                    <h3>1. Scope of Services</h3>
                                    <p>Wilson Tamuka Attorneys provides legal services across various practice areas including commercial law, litigation, conveyancing, notarial services, estate planning, mining law, data privacy, and cyber law. The specific scope of work will be outlined in your engagement letter.</p>

                                    <h3>2. Client Instructions</h3>
                                    <p>We act solely on written instructions from our clients. All instructions must be clear, complete, and provided in a timely manner. We reserve the right to decline instructions that conflict with our professional obligations or ethical standards.</p>

                                    <h3>3. Fees and Payment Terms</h3>
                                    <ul>
                                        <li>Our fees are based on the Law Society of Zimbabwe tariff of fees for Legal Practitioners</li>
                                        <li>Fees are determined by lawyer seniority, experience, complexity of the matter, and urgency</li>
                                        <li>Clients will receive transparent fee estimates and regular billing statements</li>
                                        <li>Payment terms will be specified in your engagement letter</li>
                                        <li>Disbursements and third-party costs are billed separately</li>
                                        <li>Late payments may attract interest as permitted by law</li>
                                    </ul>

                                    <h3>4. Client Responsibilities</h3>
                                    <p>Clients are expected to:</p>
                                    <ul>
                                        <li>Provide accurate and complete information</li>
                                        <li>Respond promptly to requests for information or documentation</li>
                                        <li>Pay fees and disbursements as agreed</li>
                                        <li>Inform us immediately of any changes affecting your matter</li>
                                        <li>Maintain confidentiality of legal advice received</li>
                                    </ul>

                                    <h3>5. Confidentiality and Privilege</h3>
                                    <p>All communications between you and WTA are protected by attorney-client privilege and professional confidentiality rules. We will not disclose your information except as required by law or with your consent.</p>

                                    <h3>6. Limitation of Liability</h3>
                                    <p>While we strive for excellence, our liability is limited to the extent permitted by the Law Society of Zimbabwe regulations and applicable law. We maintain professional indemnity insurance as required.</p>

                                    <h3>7. Termination of Services</h3>
                                    <p>Either party may terminate the engagement by providing written notice. Upon termination, you remain responsible for fees incurred up to the termination date. We will provide your file upon request and settlement of outstanding fees.</p>

                                    <h3>8. Conflicts of Interest</h3>
                                    <p>We conduct conflict checks before accepting new matters. If a conflict arises during representation, we will notify you immediately and take appropriate action in accordance with professional rules.</p>

                                    <h3>9. File Retention</h3>
                                    <p>We retain client files for the period required by law and professional regulations. After this period, files may be destroyed in accordance with our document retention policy.</p>

                                    <h3>10. Governing Law</h3>
                                    <p>These terms are governed by the laws of Zimbabwe. Any disputes will be resolved in accordance with Zimbabwean law and jurisdiction.</p>

                                    <h3>11. Website Use</h3>
                                    <p>Use of our website is subject to these terms. Content on our website is for general information only and does not constitute legal advice. For specific legal guidance, please contact us directly.</p>

                                    <h3>12. Amendments</h3>
                                    <p>We reserve the right to update these terms. Material changes will be communicated to active clients.</p>

                                    <p><strong>Last Updated:</strong> December 2025</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default TermPage;
